export class TeaserInit {
    constructor() {
        this.init();
    };

    init() {
        window.addEventListener('resize', (event) => {
            OVS.app.helper.sameHeight('.sameheight');
        });
        OVS.app.helper.sameHeight('.sameheight');

        document.addEventListener ("DOMContentLoaded", () => {
            let moreInfoButtons = document.querySelectorAll('.moreinfo');
            if (moreInfoButtons) {
                moreInfoButtons.forEach(element => {
                    element.click();
                });
            }
        });
    };
};
